"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MountUtils = void 0;
class MountUtils {
    constructor(mountFunction, initializationData) {
        this.mountFunction = mountFunction;
        this.initializationData = initializationData;
    }
    static initialize(vueInstance) {
        const { mountFunction, initializationData } = this.extractParameters(vueInstance);
        if (mountFunction && initializationData) {
            window.globalMountingParameters = { mountFunction, initializationData };
        }
    }
    static createInstance(vueInstance) {
        let { mountFunction, initializationData } = this.extractParameters(vueInstance);
        if ((!mountFunction || !initializationData) && window.globalMountingParameters) {
            mountFunction = window.globalMountingParameters.mountFunction;
            initializationData = window.globalMountingParameters.initializationData;
        }
        return new MountUtils(mountFunction, initializationData);
    }
    static extractParameters(vueInstance) {
        var _a, _b, _c, _d, _e, _f;
        const vueRoot = vueInstance === null || vueInstance === void 0 ? void 0 : vueInstance.$root;
        const mountFunction = (_b = (_a = vueRoot === null || vueRoot === void 0 ? void 0 : vueRoot.$data) === null || _a === void 0 ? void 0 : _a.mountParcel) !== null && _b !== void 0 ? _b : (_c = vueRoot === null || vueRoot === void 0 ? void 0 : vueRoot.$attrs) === null || _c === void 0 ? void 0 : _c.mountParcel;
        const initializationData = (_e = (_d = vueRoot === null || vueRoot === void 0 ? void 0 : vueRoot.$data) === null || _d === void 0 ? void 0 : _d.initializationData) !== null && _e !== void 0 ? _e : (_f = vueRoot === null || vueRoot === void 0 ? void 0 : vueRoot.$attrs) === null || _f === void 0 ? void 0 : _f.initializationData;
        return { mountFunction, initializationData };
    }
    async mountModule(module, props, domElement) {
        var _a, _b;
        let mountFunction = this.mountFunction;
        if (!mountFunction && process.env.NODE_ENV === 'development') {
            mountFunction = (_a = (await Promise.resolve().then(() => __importStar(require('single-spa'))))) === null || _a === void 0 ? void 0 : _a.mountRootParcel;
        }
        if (!mountFunction) {
            throw new Error('[MountUtils] "mountFunction" parameter missed.' +
                'Please check your "single-spa" initialization ' +
                'or run "npm install single-spa --save-dev" for development purpose.');
        }
        return mountFunction(this.prepareModule(module), {
            domElement,
            initializationData: (_b = this.initializationData) !== null && _b !== void 0 ? _b : {},
            ...props
        });
    }
    async mountDialog(fragmentModule, dialogModule, properties, closedCallback) {
        var _a, _b;
        const moduleToMount = dialogModule;
        if (!moduleToMount.bootstrap) {
            moduleToMount.bootstrap = fragmentModule.bootstrap;
        }
        const createdDomElement = !dialogModule.domElement ? this.createDomElement() : null;
        const mountedInstance = await this.mountModule(moduleToMount, properties, (_a = dialogModule.domElement) !== null && _a !== void 0 ? _a : createdDomElement);
        (_b = mountedInstance.unmountPromise) === null || _b === void 0 ? void 0 : _b.then(() => {
            this.removeDomElement(createdDomElement);
            closedCallback === null || closedCallback === void 0 ? void 0 : closedCallback();
        });
        return {
            close: () => mountedInstance === null || mountedInstance === void 0 ? void 0 : mountedInstance.unmount()
        };
    }
    createDomElement() {
        const element = document.createElement('div');
        document.body.appendChild(element);
        return element;
    }
    removeDomElement(element) {
        if (element) {
            document.body.removeChild(element);
        }
    }
    async prepareModule(module) {
        if (!module.bootstrap) {
            return module;
        }
        const { bootstrap, ...restModule } = module;
        if (bootstrap.loadingPromise) {
            await bootstrap.loadingPromise;
            return restModule;
        }
        let resolvePromiseFn;
        bootstrap.loadingPromise = new Promise(resolve => (resolvePromiseFn = resolve));
        return {
            bootstrap: (...args) => bootstrap(...args).then(resolvePromiseFn),
            ...restModule
        };
    }
}
exports.MountUtils = MountUtils;
